<template>
    <v-container>
        <h2 class="headline font-weight-bold mb-3">
            <v-select
                v-model="selectedSite"
                :items="sites"
                label="Select a site"
                dense
                solo
                @change="setTabular"
            ></v-select>
        </h2>

        <v-row>
            <v-col cols="12" sm="6">
                <v-text-field
                    v-model="searchText"
                    label="Search"
                    prepend-icon="mdi-magnify"
                    clearable
                    clear-icon="mdi-close-circle"
                    @click:clear="clearSearch"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
                <v-menu bottom :offset-y="true" :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            :value="dateRangeText"
                            hint="YYYY-MM-DD - YYYY-MM-DD format"
                            label="Date range"
                            :rules="rules"
                            prepend-icon="mdi-calendar"
                            @change="validateDates"
                            clearable
                            clear-icon="mdi-close-circle"
                            @click:clear="clearMessage"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="dates"
                        range
                        v-on:change="handleDate"
                        no-title
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="items"> </v-data-table>
    </v-container>
</template>

<script>
import axios from "axios";
export default {
    name: "Tabular",
    data() {
        return {
            sites: ["SIRTA", "P2OA", "COPDD"],
            selectedSite: "",
            rules: [this.validateDateRule],
            dates: [],
            result: [],
            allItems: [],
            searchText: "",
            headers: [
                {
                    text: "Standard Name",
                    value: "name",
                    align: "start",
                    sortable: true,
                    width: "15%",
                },
                { text: "Description", value: "long_name", width: "35%" },
                { text: "Unit", value: "units", width: "10%" },
                { text: "Measures starting", value: "beg_date", width: "20%" },
                { text: "Measures ending", value: "end_date", width: "20%" },
            ],
        };
    },
    computed: {
        dateRangeText() {
            return this.dates.join(" - ");
        },
        items() {
            return this.filterSearch(this.filterFromDate(this.allItems));
        },
    },
    methods: {
        validateDateRule(value) {
            const dateValidator = /^(\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])) - (\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]))$/;
            const onlyOneDateValidator = /^(\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]))/;
            if (dateValidator.test(value)) {
                return true;
            } else if (onlyOneDateValidator.test(value)) {
                return "Two dates are required";
            } else if (value === "" || value === null) {
                return true;
            } else {
                return "YYYY-MM-DD - YYYY-MM-DD format";
            }
        },
        clearMessage() {
            this.dates = [];
        },
        clearSearch() {
            this.searchText = "";
        },
        setItems() {
            for (let variable in this.result) {
                let newItem = {
                    name: variable,
                    long_name: this.result[variable]["long_name"],
                    units: this.result[variable]["units"],
                    beg_date: this.result[variable]["beg_date"],
                    end_date: this.result[variable]["end_date"],
                };
                this.allItems.push(newItem);
            }
        },
        setTabular() {
            if (this.selectedSite !== "") {
                axios
                    .get(
                        "https://observations.ipsl.fr/aeris/reobs/data/" +
                            this.selectedSite.toLowerCase() +
                            "/json/reobs_infos.json"
                    )
                    .then((response) => {
                        this.result = response.data["variables"];
                        this.allItems = [];
                        this.setItems();
                    });
            }
        },
        validateDates(dates) {
            const dateValidator = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]) - \d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
            if (dateValidator.test(dates)) {
                dates = dates.split(" - ");
                this.dates = dates;
            } else if (dates === "") {
                this.dates = [];
            }
        },
        filterSearch(product) {
            return product.filter((item) => {
                let isInDescription = false;
                let isInName = false;
                if (!(item["name"] === undefined)) {
                    isInName = item["name"]
                        .toLowerCase()
                        .includes(this.searchText.toLowerCase());
                }
                if (!(item["long_name"] === undefined)) {
                    isInDescription = item["long_name"]
                        .toLowerCase()
                        .includes(this.searchText.toLowerCase());
                }
                if (isInName || isInDescription) {
                    return item;
                }
            });
        },
        handleDate(dates) {
            if (dates.length !== 2) {
                return;
            }
            let orderedDates = dates;
            let BegDateFromCalendar = new Date(dates[0]);
            let EndDateFromCalendar = new Date(dates[1]);
            if (BegDateFromCalendar > EndDateFromCalendar) {
                [EndDateFromCalendar, BegDateFromCalendar] = [
                    BegDateFromCalendar,
                    EndDateFromCalendar,
                ];
                orderedDates = [dates[1], dates[0]];
            }
            this.dates = orderedDates;
        },

        filterFromDate(product) {
            if (this.dates.length !== 2) {
                return product;
            }
            let BegDateFromCalendar = new Date(this.dates[0]);
            let EndDateFromCalendar = new Date(this.dates[1]);
            let items = [];
            for (let item of product) {
                let strEndDateFulStr = item["end_date"];
                if (strEndDateFulStr === undefined) {
                    continue;
                }
                let strBegDateFulStr = item["beg_date"];
                if (strBegDateFulStr === undefined) {
                    continue;
                }

                let EndDateFromVar = new Date(strEndDateFulStr.split("T")[0]);
                let BegDateFromVar = new Date(strBegDateFulStr.split("T")[0]);

                let BegDateValid =
                    BegDateFromCalendar <= EndDateFromVar &&
                    BegDateFromCalendar >= BegDateFromVar;
                let EndDateValid =
                    EndDateFromCalendar >= BegDateFromVar &&
                    EndDateFromCalendar <= EndDateFromVar;

                if (BegDateValid || EndDateValid) {
                    let newItem = {
                        name: item["name"],
                        long_name: item["long_name"],
                        units: item["units"],
                        beg_date: item["beg_date"],
                        end_date: item["end_date"],
                    };
                    items.push(newItem);
                }
            }
            return items;
        },
    },
};
</script>

<style>
.container {
    padding: 0px;
    margin-right: 0;
    margin-left: 0;
}
</style>
